import { request } from '@/utils/request'

export const reqStoreList = (params) =>
  request.get(`cooperative_store/storelist`, { params })

export const reqDeleteStore = (id) => request.delete(`removestore?id=${id}`)



// WEBPACK FOOTER //
// ./src/api/specialContract/index.js